import React from 'react';
import { BikeImage } from './ListingCard';

const WA_LINK = 'https://wa.me/971585338786';

export default function ListingDetail({ listing, onClose }) {
  if (!listing) return null;

  const waLink = `${WA_LINK}?text=Hi%20I%20am%20interested%20in%20the%20${encodeURIComponent(listing.name)}%20(AED%20${listing.price})`;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content fade-in" onClick={e => e.stopPropagation()}>
        <BikeImage brand={listing.brand} photos={listing.photos} />
        <div style={{ padding: 24 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start', marginBottom: 8 }}>
            <h2 style={{ fontSize: 22 }}>{listing.name}</h2>
            <button onClick={onClose} style={{ background: 'none', border: 'none', color: 'var(--text-2)', cursor: 'pointer', fontSize: 20 }}>✕</button>
          </div>
          <p style={{ fontSize: 28, fontWeight: 700, color: 'var(--volt)', marginBottom: 16, fontFamily: "'Space Grotesk'" }}>AED {listing.price?.toLocaleString()}</p>
          <p style={{ color: 'var(--text-2)', fontSize: 14, lineHeight: 1.6, marginBottom: 20 }}>{listing.description}</p>

          {/* Photo gallery */}
          {listing.photos && listing.photos.length > 1 && (
            <div style={{ display: 'flex', gap: 8, marginBottom: 20, overflowX: 'auto' }}>
              {listing.photos.map((photo, i) => (
                <img key={i} src={photo} alt={`${listing.name} ${i + 1}`} style={{ width: 100, height: 100, objectFit: 'cover', borderRadius: 8, flexShrink: 0 }} />
              ))}
            </div>
          )}

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 24 }}>
            {[
              ['Brand', listing.brand],
              ['Year', listing.year],
              ['Condition', listing.condition],
              ['Battery', listing.battery],
              ['Mileage', listing.mileage],
              ['Location', listing.location],
            ].map(([k, v]) => (
              <div key={k} style={{ background: 'var(--dark-3)', padding: 12, borderRadius: 8 }}>
                <p style={{ fontSize: 11, color: 'var(--text-3)', textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 4 }}>{k}</p>
                <p style={{ fontSize: 14, fontWeight: 500 }}>{v}</p>
              </div>
            ))}
          </div>

          <div style={{ display: 'flex', gap: 12 }}>
            <a href={waLink} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', flex: 1 }}>
              <button className="btn-wa" style={{ width: '100%', justifyContent: 'center' }}>💬 WhatsApp to Reserve</button>
            </a>
            <a href="tel:+971585338786" style={{ textDecoration: 'none' }}>
              <button className="btn-outline">📞</button>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
